export default __webpack_public_path__ + "static/media/likewatt-blanc-short.af418245.png";